import { Controller } from "@hotwired/stimulus"

// Controller to preview PDF files before saving using PDF.js
export default class extends Controller {
  static targets = ["canvas", "previewContainer", "uploadPrompt", "pageInfo", "pickButton", "manualButton"]
  static values = {
    hasPreview: { type: Boolean, default: false }
  }

  connect() {
    // If there's already a server-side preview, hide the upload prompt
    if (this.hasPreviewValue && this.hasUploadPromptTarget) {
      this.uploadPromptTarget.classList.add("hidden")
    }
  }

  async loadPdf(event) {
    console.log('PDF Preview: loadPdf called', event)
    const file = event.target.files[0]
    console.log('PDF Preview: file selected', file)
    
    if (!file || file.type !== 'application/pdf') {
      console.log('PDF Preview: no file or not PDF, returning')
      return
    }

    console.log('PDF Preview: starting to load PDF...')
    try {
      // Show preview container, hide upload prompt
      console.log('PDF Preview: has container?', this.hasPreviewContainerTarget)
      console.log('PDF Preview: has upload prompt?', this.hasUploadPromptTarget)
      
      if (this.hasPreviewContainerTarget) {
        console.log('PDF Preview: showing preview container')
        this.previewContainerTarget.classList.remove("hidden")
      }
      if (this.hasUploadPromptTarget) {
        console.log('PDF Preview: hiding upload prompt')
        this.uploadPromptTarget.classList.add("hidden")
      }

      // Load PDF.js library dynamically if not already loaded
      if (!window.pdfjsLib) {
        await this.loadPdfJs()
      }

      // Read the file as ArrayBuffer
      const arrayBuffer = await file.arrayBuffer()

      // Load the PDF document
      const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise

      // Render first page
      await this.renderPage(pdf, 1)

      // Update page info
      if (this.hasPageInfoTarget) {
        this.pageInfoTarget.textContent = `Page 1 of ${pdf.numPages}`
      }

      // Store PDF for later use (e.g., page navigation)
      this.pdf = pdf
      this.currentPage = 1

      // Show the coordinate picker button, hide manual button
      if (this.hasPickButtonTarget) {
        this.pickButtonTarget.classList.remove("hidden")
      }
      if (this.hasManualButtonTarget) {
        this.manualButtonTarget.classList.add("hidden")
      }

      // Dispatch event to notify coordinate picker
      this.dispatch("loaded")

    } catch (error) {
      console.error('Error loading PDF:', error)
      alert('Error loading PDF. Please try again.')
    }
  }

  async renderPage(pdf, pageNumber) {
    try {
      const page = await pdf.getPage(pageNumber)
      const canvas = this.canvasTarget
      const context = canvas.getContext('2d')

      // Calculate scale to fit container
      const viewport = page.getViewport({ scale: 1.0 })
      const containerWidth = canvas.parentElement.clientWidth - 16 // Account for padding
      const scale = containerWidth / viewport.width

      const scaledViewport = page.getViewport({ scale })

      // Set canvas dimensions
      canvas.width = scaledViewport.width
      canvas.height = scaledViewport.height

      // Add data attributes for coordinate picking
      canvas.dataset.pageNumber = pageNumber

      // Render PDF page
      await page.render({
        canvasContext: context,
        viewport: scaledViewport
      }).promise

    } catch (error) {
      console.error('Error rendering page:', error)
    }
  }

  async loadPdfJs() {
    return new Promise((resolve, reject) => {
      // Load PDF.js from CDN
      const script = document.createElement('script')
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js'
      script.onload = () => {
        // Set worker path
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = 
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'
        resolve()
      }
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
}
